import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import LoyaltyLandingPageUSPSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageUSPSection'
import LoyaltyLandingPageHowItWorksSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageHowItWorksSection'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import LoyaltyUserBronzeHero from './LoyaltyUserBronzeHero'
import LoyaltyUserSilverHero from './LoyaltyUserSilverHero'
import LoyaltyUserGoldHero from './LoyaltyUserGoldHero'
import LoyaltyLandingPageBenefitsTableSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageBenefitsTableSection'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import LoyaltyLandingPageDiscoverTiersSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageDiscoverTiersSection'
import LoyaltyLandingPageFaqSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageFaqSection'
import LoyaltyUserBronzeBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserBronzeBenefits'
import LoyaltyUserGoldBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserGoldBenefits'
import LoyaltyUserSilverBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserSilverBenefits'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import TriplePointTakeoverHeroCarousel from 'takeovers/societyTriplePointsTakeover/components/TriplePointTakeoverHeroCarousel'
import { useCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { triplePointsTakeoverId } from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeoverConfig'

function LoyaltyGuestLandingPage() {
  const dispatch = useAppDispatch()
  const [eligibilityTier, fetchingEligibility] = useLoyaltyUserEligibilityTier()
  const currentSiteTakeover = useCurrentSiteTakeover()
  const triplePointCampaignActive = currentSiteTakeover?.id === triplePointsTakeoverId
  const onJoinClick = useCallback(() => {
    dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
  }, [dispatch])

  if (fetchingEligibility) {
    return <LoadingIndicator />
  }

  return <div>
    {eligibilityTier === 'bronze' && <LoyaltyUserBronzeHero onActivate={onJoinClick} />}
    {eligibilityTier === 'silver' && <LoyaltyUserSilverHero onActivate={onJoinClick} />}
    {eligibilityTier === 'gold' && <LoyaltyUserGoldHero onActivate={onJoinClick} />}
    {triplePointCampaignActive && <TriplePointTakeoverHeroCarousel
      viewOffersTo="/triple-points"
    />}
    <LoyaltyLandingPageUSPSection />
    <Pane background="light-background">
      <LayoutContainer variant="medium">
        {eligibilityTier === 'bronze' && <LoyaltyUserBronzeBenefits onActivate={onJoinClick} />}
        {eligibilityTier === 'silver' && <LoyaltyUserSilverBenefits onActivate={onJoinClick} />}
        {eligibilityTier === 'gold' && <LoyaltyUserGoldBenefits onActivate={onJoinClick} />}
      </LayoutContainer>
    </Pane>
    <LoyaltyLandingPageDiscoverTiersSection />
    <LoyaltyLandingPageBenefitsTableSection highlightTier={eligibilityTier} onJoin={onJoinClick} />
    <LoyaltyLandingPageHowItWorksSection onJoin={onJoinClick} />
    <LoyaltyLandingPageFaqSection slug="societe-faqs" />
  </div>
}

export default LoyaltyGuestLandingPage
